var map = {
	"./qilin-stage1-sulking.png": "a10b",
	"./qilin-stage2-sulking.png": "681e",
	"./qilin-stage3-sulking.png": "4f7e",
	"./qilin-stage4-sulking.png": "d24c",
	"./qilin-stage5-sulking.png": "e39b",
	"./qilin-stage6-sulking.png": "e751",
	"./qilin-stage7-sulking.png": "2aaa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f8a6";